import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasAccepted = localStorage.getItem('cookieconsent');
    if (!hasAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieconsent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 bg-white rounded-lg shadow-lg p-6 max-w-md z-50">
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-lg font-semibold">Guess what? Cookies!</h3>
        <img src="/images/cookie-icon.svg" alt="Cookie" className="w-8 h-8" />
      </div>
      
      <p className="text-gray-600 text-sm mb-4">
        We use essential cookies to offer you a better website experience. We'd like to use other cookies to analyze our
        website's performance and personalize your experience, but only if you accept. Learn more about your choices in our{' '}
        <Link to="/cookies" className="text-blue-500 hover:underline">
          cookie policy
        </Link>
        .
      </p>
      
      <div className="flex gap-3">
        <button
          onClick={handleAcceptAll}
          className="bg-[#44484f] text-white px-6 py-2 rounded hover:bg-[#373b42] transition-colors"
        >
          Accept All
        </button>
        <button
          onClick={() => setIsVisible(false)}
          className="text-[#44484f] px-6 py-2 rounded hover:bg-gray-100 transition-colors"
        >
          Only the Essentials Please
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;